<style>
  .suggested-resources--disabled {
    opacity: 0.7;
  }
  @keyframes spin {
    100% {
      transform:rotate(360deg);
    }
  }
</style>

<template>
  <v-card-text style="max-height: 440px; padding: 0;">
    <v-alert
      dense
      type="info"
      text
      style="margin: 0; padding: 7px; font-size: 14px;"
    >
      <div>
        {{ this.openAIPrompt }}
      </div>
    </v-alert>

    <div style="display: flex; gap: 20px; margin-top: 10px;">
      <v-text-field
        :placeholder="translate('ui_dialog_search_quick_select_openai')"
        outlined
        dense
        background-color="white"
        v-model="searchString"
        :disabled="this.isCallingOpenAI"
      ></v-text-field>
      <v-btn
        @click="askOpenAI"
        :disabled="this.isCallingOpenAI"
        style="margin-right: 5px;"
      >
        <v-icon
          left
        >
          mdi-cloud-question-outline
        </v-icon>
        {{ translate('ui_dialog_openai') }}
      </v-btn>
    </div>

    <div>
      <div style="position: relative;">
        <div
          v-show="this.isCallingOpenAI"
          style="display: flex; justify-content: center; align-items: center; position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);"
        >
          <img
            style="width: 50px;
    height: 50px;
    animation:spin 4s linear infinite;"
            src="/img/openai-logomark.png"
          />
        </div>

        <v-list
          style="width: 100%; margin: 0px;
              padding: 0px;
              height: 250px;
              overflow-x: hidden;"
          class="suggested-resources"
          :class="{ 'suggested-resources--disabled': this.isCallingOpenAI }"
          :disabled="this.isCallingOpenAI"
        >
          <v-list-item-group>
            <v-list-item
              v-for="(resource, i) in this.suggestedResources"
              :key="i"
              style="min-height: initial;"
              @click="increment(resource)"
            >
              <v-list-item-action
                style="align-self: center; margin-right: 16px;"
              >
                <v-btn
                  fab
                  outlined
                  x-small
                  style="text-transform: initial; width: 26px; height: 26px;"
                  :style="[getCount(resource) > 0 ? {backgroundColor: '#1976d2', color: '#fff'} : {backgroundColor: '#fff', color: '#1976d2'}]"
                >
                  <v-icon
                    v-if="getCount(resource) === 0"
                    :title="translate('ui_add_btn')"
                    style="font-style: initial; font-size: 16px;"
                  >
                    mdi-plus
                  </v-icon>
                  <v-icon
                    v-if="getCount(resource) > 0"
                    :title="translate('ui_add_btn')"
                    style="font-style: initial; font-size: 16px;"
                  >
                    x{{ getCount(resource) }}
                  </v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-content style="cursor: pointer;">
                <v-list-item-title
                  style="display: flex; justify-content: space-between;"
                >
                  <div
                    :title="resource.name"
                  >{{resource.name}}</div>
                </v-list-item-title>
                <!--
                <v-card-subtitle
                  v-if="resource.formula"
                  style="padding: 5px 0;"
                >
                  {{ resource.formula.name[$store.state.activeTemplate.language] || resource.formula.name}}
                </v-card-subtitle>
                -->
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
    </div>
  </v-card-text>
</template>

<script>

// mixins
import Mixin from '@/mixins/mixin';

export default {
  name: 'DialogResourceAddOpenAI',
  components: {},
  props: {
    selectedResources: Array,
    section: Object,
  },
  mixins: [Mixin],
  data() {
    return {
      suggestedResources: [],
      selectedResourceIndexes: [],
      selectedGroup: null,
      searchString: '',
      displaySearchField: false,
      isCallingOpenAI: false,
    };
  },
  mounted() {
    this.searchString = this.$store.state.activeTemplate.data.openAIPrompt || ''; // this.$store.state.activeTemplate.name;
    this.suggestedResources = this.section.suggestedResources;
  },
  methods: {
    async askOpenAI() {
      if (!this.searchString) {
        this.searchString = 'cafe';
      }
      this.isCallingOpenAI = true;
      this.$emit('updateSelectedResources', []);
      const suggestedResources = await this.$store.dispatch('getOpenAI', {
        searchString: this.searchString,
        sectionId: this.section.id,
      });
      this.suggestedResources = suggestedResources;
      // save prompt
      this.$store.commit('updateState', {
        path: 'activeTemplate.data.openAIPrompt',
        value: this.searchString,
      });
      this.isCallingOpenAI = false;
    },
    getCount(resource) {
      const selectedResource = this.selectedResources.find((r) => r.id === resource.id);
      return selectedResource ? selectedResource.count : 0;
    },
    increment(resource) {
      const selectedResource = this.selectedResources.find((r) => r.id === resource.id);
      if (!selectedResource) {
        this.selectedResources.push({
          id: resource.id,
          name: resource.name,
          rel: resource.rel,
          formula: resource.formula && JSON.parse(JSON.stringify(resource.formula)),
          count: 1,
        });
      } else {
        // eslint-disable-next-line
        if (selectedResource.count === 5) {
          const selectedResourceIndex = this.selectedResources.findIndex((r) => r.id === resource.id);
          this.selectedResources.splice(selectedResourceIndex, 1);
        } else {
          selectedResource.count += 1;
        }
      }
      this.$emit('updateSelectedResources', this.selectedResources);
    },
    // highlightSearchString(resource) {
    //   let result = resource.name;
    //   console.log(result);
    //   if (this.searchString.length) {
    //     const re = new RegExp(`(?<!>)${this.searchString}`, 'ig');
    //     // eslint-disable-next-line
    //     result = result.replace(re, (match) => {
    //       return `<span style="color: orangered;">${match}</span>`;
    //     });
    //   }
    //   return result;
    // },
  },
  computed: {
    openAIPrompt() {
      const { language } = this.$store.state.activeTemplate;
      let resourceType = '';
      switch (this.section.id) {
        case 'section_sales':
          resourceType = language === 'en' ? 'income' : 'доходы';
          break;
        case 'section_sga':
          resourceType = language === 'en' ? 'expenses' : 'расходы';
          break;
        case 'section_fixedassets':
          resourceType = language === 'en' ? 'fixed assets' : 'капитальные затраты';
          break;
        default:
        // nothing
      }
      const prompt = this.translate('ui_dialog_openai_prompt').replace('[resourceType]', resourceType);
      return prompt;
    },
    predefinedResourcesGroups() {
      return false;
      // return [{
      //   id: 'all',
      //   name: 'All',
      // }, {
      //   id: 'restaurant',
      //   name: 'Restaurant',
      // }];
    },
  },
};
</script>
